/* <s-free-ship>: confetti burst the first time a visit reaches free shipping (see snippets/free-shipping-bar.liquid). Loaded globally so bars inserted by cart partial refreshes still upgrade. */
if (!customElements.get('s-free-ship')) {
  customElements.define('s-free-ship', class extends HTMLElement {
    connectedCallback() {
      const KEY = 'ksv:free-ship-celebrated';
      if (this.dataset.reached !== 'true') {
        sessionStorage.removeItem(KEY);
        return;
      }
      if (sessionStorage.getItem(KEY)) return;
      sessionStorage.setItem(KEY, '1');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      requestAnimationFrame(() => this.burst());
    }

    burst() {
      const rect = this.getBoundingClientRect();
      if (!rect.width) return;
      const styles = getComputedStyle(document.documentElement);
      const colors = ['--color-gold', '--color-success', '--color-sale', '--color-interactive', '--color-border']
        .map((name) => styles.getPropertyValue(name).trim())
        .filter(Boolean);
      const layer = document.createElement('div');
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;';
      document.body.append(layer);
      const originX = rect.left + rect.width / 2;
      const originY = rect.top + rect.height / 2;
      const pieces = 60;
      let done = 0;
      for (let i = 0; i < pieces; i += 1) {
        const piece = document.createElement('span');
        const w = 5 + Math.random() * 5;
        const h = Math.random() > 0.5 ? w : w * 1.8;
        piece.style.cssText = `position:absolute;left:${originX}px;top:${originY}px;width:${w}px;height:${h}px;background:${colors[i % colors.length]};border-radius:${Math.random() > 0.6 ? '50%' : '1px'};`;
        layer.append(piece);
        const dx = (Math.random() - 0.5) * Math.min(window.innerWidth, 640);
        const up = -(80 + Math.random() * 180);
        const fall = 260 + Math.random() * 260;
        const spin = (Math.random() - 0.5) * 1080;
        piece.animate([
          { transform: 'translate(-50%, -50%) rotate(0deg)', opacity: 1 },
          { transform: `translate(calc(-50% + ${dx * 0.7}px), calc(-50% + ${up}px)) rotate(${spin / 2}deg)`, opacity: 1, offset: 0.35 },
          { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${up + fall}px)) rotate(${spin}deg)`, opacity: 0 },
        ], { duration: 1600 + Math.random() * 900, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' }).finished.then(() => {
          done += 1;
          if (done === pieces) layer.remove();
        });
      }
    }
  });
}
